var React = require('react');

function Pen (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19.5 42.5H11M44 16L25 34L28 37L37.5 28L47 19L44 16ZM24 35L21 40.5L27 38L24 35Z","stroke":"black","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"59","height":"59","stroke":"#C3C2C1","key":1})]);
}

Pen.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = Pen;

Pen.default = Pen;
